import Vue from 'vue';
import List from './components/references-list/List.vue';

$(function () {
    $('.legacy-layout .references-list-block').each(function () {
        new Vue({
            el: this,
            components: {List}
        })
    });
});
